import { debounce } from "lodash";

const numberContainerEls = document.querySelectorAll("[data-custom-number]");
const debounceDelay = 1000;

try {
  numberContainerEls.forEach((numberContainerEl) => {
    const increaseBtnEl = numberContainerEl.querySelector("[data-custom-number-increase]");
    const decreaseBtnEl = numberContainerEl.querySelector("[data-custom-number-decrease]");
    const inputEl = numberContainerEl.querySelector("[data-custom-number-input]");
    let submitOnChange = numberContainerEl.hasAttribute("data-custom-number-submit-on-change");

    if (!inputEl) return;

    const min = inputEl.hasAttribute("min") ? parseInt(inputEl.min, 10) : null;
    const max = inputEl.hasAttribute("max") ? parseInt(inputEl.max, 10) : 999;
    const getValue = () => parseInt(inputEl.value, 10) || min || 0;
    const setValue = (v) => (inputEl.value = parseInt(v, 10));
    const formEl = numberContainerEl.closest("form");
    let value = getValue();

    const dispatchChangeEvent = () => {
      inputEl.dispatchEvent(new Event("change", { bubbles: true }));
    };

    const dispatchSubmitEvent = () => {
      formEl.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    };

    const dispatchEvent = debounce(
      submitOnChange && formEl ? dispatchSubmitEvent : dispatchChangeEvent,
      debounceDelay,
    );

    const updateValue = (newValue) => {
      newValue = newValue > 0 ? newValue : 0;
      if (min !== null && newValue < min) newValue = min;
      if (max !== null && newValue > max) newValue = max;
      value = newValue;
      setValue(value);
    };

    const increment = () => {
      updateValue(value + 1);
      dispatchEvent();
    };
    const decrement = () => {
      updateValue(value - 1);
      dispatchEvent();
    };

    if (increaseBtnEl) {
      increaseBtnEl.addEventListener("click", (e) => {
        e.preventDefault();
        increment();
      });
    }

    if (decreaseBtnEl) {
      decreaseBtnEl.addEventListener("click", (e) => {
        e.preventDefault();
        decrement();
      });
    }

    inputEl.addEventListener("keydown", (e) => {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        increment();
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        decrement();
      } else if (e.key === "Enter") {
        e.preventDefault();
        setTimeout(() => {
          dispatchSubmitEvent();
        }, 100);
      }
    });

    inputEl.addEventListener("input", () => {
      const value = parseInt(getValue(), 10);
      if (value < 0) updateValue(0);
      else updateValue(value);
    });

    inputEl.addEventListener(
      "paste",
      debounce((e) => {
        e.preventDefault();
        const paste = (e.clipboardData || window.clipboardData).getData("text");
        const parsedValue = parseInt(paste, 10);
        if (!isNaN(parsedValue)) updateValue(parsedValue);
      }, debounceDelay),
    );
  });
} catch (error) {}
